export function handleLoadPosts() {

  $('.post-grid-block .load-more').click(handleClickLoadMoreButton)
  $('#filterTag').change(handleChangePostCat);
  $('.button-tabs').click(function() {
    let tabs = $(this).data('tabs')
    $(`#pills-tab a[href="${tabs}"]`).trigger('click');
    $( window ).ready(function() {
      $('.category-wrapper').css('height',$('.tab-content').outerHeight() + 200)
    });
  });
  $('.button-intro').click(function() {
    $(this).removeClass('active')
    $('.hof-search').hide()
  });
  $('.hof-tabs').click(function() {
    $('.hof-search').show()
    $( window ).ready(function() {
      $('.category-wrapper').css('height',$('.tab-content').outerHeight() + 200)
    });
    $('html, body').animate({
      scrollTop: $('.tab-content').offset().top - 200,
    });
  });
  $( window ).load(function() {
    $('.category-wrapper').css('height',$('.tab-content').height() + 200);
    var urlParams = new URLSearchParams(window.location.search);
      if (urlParams.has('cat')){
        let hash = urlParams.get('cat').toLowerCase();
        $('#filterTag').val(hash);
        $('#filterTag').change();

        const keyword = $('.search-input-hof').val()
        $('#pills-tab a[href="#pills-all"]').trigger('click');
        getPosts({
          preRequest: preLoadPosts,
          hash,
          page: 1,
          search: keyword,
        });
      }
  });
  $('.btn-show').on('click', function () {

    $( window ).ready(function() {
      $('.category-wrapper').css('height', $('.tab-content').outerHeight() + 200)
    });
  });
  handlePressEnter()
}

function handlePressEnter() {
  const searchInput = $('.search-input-hof')
  searchInput.keypress(function(e) {
    const keyword = searchInput.val()
    if (e.key === 'Enter' && keyword !== '') {
      const category = $('.post-grid-block').attr('data-category')
      $('#pills-tab a[href="#pills-all"]').trigger('click');
      getPosts({
        preRequest: preLoadPosts,
        category,
        page: 1,
        search: keyword,
      });
      $( window ).ready(function() {
        $('.category-wrapper').css('height',$('.tab-content').outerHeight() + 300)
      });
    }
  })
  $('.icon-search-hof').click(function() {
    const keyword = searchInput.val()
    const category = $('.post-grid-block').attr('data-category')

    $('#pills-tab a[href="#pills-all"]').trigger('click');
    getPosts({
      preRequest: preLoadPosts,
      category,
      page: 1,
      search: keyword,
    });
    $( window ).ready(function() {
      $('.category-wrapper').css('height',$('.tab-content').outerHeight() + 300)
    });
  })
}


let ajax

function preLoadPosts() {
  const postList = $('.post-grid')
  const loadingIndicator = $('.reload')
  postList.addClass('loading')
  loadingIndicator.removeClass('d-none')
}
function handleChangePostCat(e) {
  e.preventDefault();
  let category = $('#filterTag').val();

  const keyword = $('.search-input-hof').val()
  $('#pills-tab a[href="#pills-all"]').trigger('click');
  getPosts({
    preRequest: preLoadPosts,
    category,
    page: 1,
    search: keyword,
  });
}

function handleClickLoadMoreButton() {
  const page = Number($('.post-grid-block').attr('data-page')) + 1
  const category = $('.post-grid-block').attr('data-category')
  const keyword = $('.search-input-hof').val()
  getPosts({ page: page, category , search: keyword})
}

function getPosts({ page, category, preRequest, search = '' }) {
  if (ajax) {
    ajax.abort()
  }

  !!preRequest && preRequest()

  const postGridBlock = $('.post-grid-block')
  const postsPerPage = postGridBlock.data('posts-per-page')
  const noPostsFoundMessage = postGridBlock.data('no-posts-found-message') || 'No Posts Found.'
  const postList = $('.post-grid')
  const loadMoreWrap = $('.load-more-wrap')
  const loadMoreButton = loadMoreWrap.find('.load-more')
  const loadingIndicator = loadMoreWrap.find('.loading-spinner')
  postGridBlock.attr('data-category', category)
  let url = new URL(window.location.href)
  url.searchParams.append('paged', page)
  if (search && category) {
    url.href += '&search=' + search.trim() + '&cat=' + category
  } else {
    if(search) {
      url.href += '&search=' + search.trim()
    }else {
      if (category) url.href += '&cat=' + category
    }
  }
  if (page > 1) {
    loadMoreButton.addClass('d-none').attr('disabled', 'disabled')
    loadingIndicator.removeClass('d-none')
  }
  ajax = $.ajax({
    url: url.href,
    success: function(res) {
      let postListHtml = ''
      const postsInListRes = $(res).find('.post-card-wrap') || []
      const postsInResCount = postsInListRes.length
      const canLoadMore = postsInResCount === postsPerPage

      $.each(postsInListRes, function(index, post) {
        postListHtml += post.outerHTML
      })

      if (page === 1) {
        postList.find('.post-card-wrap').remove()
        if (postListHtml) {
          postList.prepend(postListHtml)
          $('.no-posts-found').remove()
        } else {
          postList.html(`<p class="no-posts-found mx-auto"><b>${noPostsFoundMessage}</b></p>`)
        }
      } else {
        const newPosts = $(postListHtml)
        postList.append(newPosts)
        focusFirstLoadedPost(newPosts)
        loadMoreButton.removeAttr('disabled')
        loadingIndicator.addClass('d-none')
      }

      if (!canLoadMore) {
        loadMoreButton.addClass('d-none')
      } else {
        loadMoreButton.removeClass('d-none')
      }
      postGridBlock.attr('data-page', page)
    },
    error: function() {},
  })
}

function focusFirstLoadedPost(posts) {
  const focusable = posts.first().find('a[href], button:not([disabled]), input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])').first()

  if (focusable.length) {
    focusable.focus()
  }
}



// WEBPACK FOOTER //
// ./scripts/func/loadPosts.js